<template>
  <footer>
    <ul>
      <li><a href="https://www.youtube.com/channel/UCNrKf4FUAN6E8NoSDKV20Ng">YouTube</a></li>
      <li><a href="https://discord.gg/Sn4G4Jx">Discord</a></li>
      <li><router-link to="/blog">Blog</router-link></li>
      <li><router-link to="/help">Help</router-link></li>
      <li><router-link to="/about">About</router-link></li>
      <li><router-link to="/contact">Contact</router-link></li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'ppt-footer',
  computed: {
    loggedIn: function () {
      return this.$store.getters['account/loggedIn'];
    },
  },
};
</script>

<style lang="scss" scoped>
  footer {
    margin-top: 30px;
    border-top: 1px solid lightgray;
    padding: 30px 0;
    font-size: 18px;

    ul {
      list-style-type: none;
      margin-bottom: 0;
      padding-left: 0;
      text-align: center;
    }

    li {
      display: inline-block;
      padding: 0 20px;
    }

    @media (max-width: 620px) {
      li {
        display: block;
        padding: 15px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue